<template>
  <b-container class="text-center">
    <br /><br />
    <div v-if="jpToken == '' || jpToken == undefined">
      C'è stato un problema, token non trovato!
    </div>

    <div v-else>
      <span v-if="this.$router.currentRoute.query.status == 'PLACED'">
        Attendi, stiamo effettuando la prenotazione richiesta...
      </span>

      <span v-else> Attendi, stiamo processando la tua richiesta... </span>

      <br /><br />
      <Spinner v-if="loading" />
    </div>
    <br /><br />
  </b-container>
</template>

<script>
//import Router from 'vue-router'
import Spinner from '@/components/atoms/spinner';
import { jp_checkout } from '@/api';

export default {
  name: 'jp-checkout',
  components: {
    Spinner,
  },
  props: {},
  data() {
    return {
      jpToken: '',
      jpStatus: '',
      loading: true,
    };
  },
  mounted() {
    this.jpToken = this.$router.currentRoute.query.jpToken;
    this.jpStatus = this.$router.currentRoute.query.status;

    if (this.jpToken !== undefined) {
      this.jpCheckout();
    } else {
      this.loading = false;
    }
  },
  methods: {
    jpCheckout() {
      //window.console.log('counter: '+ this.counter)

      jp_checkout({
        jpToken: this.jpToken,
        status: this.jpStatus,
      }).then(
        (success) => {
          window.console.log('SUCCESS');
          window.console.log(success);

          this.loading = false;

          window.location.href =
            '/confirm/' + success.data.flightVoucherId.toString() + '/' + success.data.confirmcode;
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
};
</script>
